  import {AfterViewInit, Component, isDevMode, OnInit, ViewChild} from '@angular/core';
  import {environment} from "../../../../../../environments/environment";
  import {MatTableDataSource} from "@angular/material/table";
  import {AngularFirestore} from "@angular/fire/compat/firestore";
  import {CounselingService} from "../../../counseling.service";
  import {firstValueFrom, Observable, take} from "rxjs";
  import {map} from 'rxjs/operators';
  import {Centre} from "../../../../../interfaces/Centres";
  import {CentreService} from "../../../../../services/centre.service";
  import {MatPaginator} from "@angular/material/paginator";
  import {PermissionType} from "../../../../../components/employee/PermissionType.enum";
  import {Router} from "@angular/router";
  import {MatDialog} from "@angular/material/dialog";
  import {
    AddEditCounsellingCentreLogComponent
  } from "../add-edit-counselling-centre-log/add-edit-counselling-centre-log.component";

  @Component({
    selector: 'app-counselling-center-log',
    templateUrl: './counselling-center-log.component.html',
    styleUrls: ['./counselling-center-log.component.scss']
  })
  export class CounsellingCenterLogComponent implements OnInit ,AfterViewInit {
    env = isDevMode() ? environment.testMode : environment.productionMode;
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    months = [
      {name: "January", value: 1},
      {name: "February", value: 2},
      {name: "March", value: 3},
      {name: "April", value: 4},
      {name: "May", value: 5},
      {name: "June", value: 6},
      {name: "July", value: 7},
      {name: "August", value: 8},
      {name: "September", value: 9},
      {name: "October", value: 10},
      {name: "November", value: 11},
      {name: "December", value: 12},
    ];
    years = [2024, 2025, 2026];

    selectedMonth: number | null = null;
    selectedYear: number | null = null;

    displayedColumns: string[] = [
      'no', 'centreName', 'childName', 'session', 'type', 'date', 'remark', 'sessionDocumented', 'action'
    ];


    dataSource = new MatTableDataSource<any>([]);
    centres$: Observable<Centre[]>
    centresWithAll$: Observable<any[]>;
    allData: any[] = [
      {
        center: 'Diamond',
        child: 'ABC',
        session: 'Session 1',
        type: 'Admission',
        date: '2025-09-03',
        remark: 'Manual typing'
      },
      {
        center: 'Diamond',
        child: 'ABC',
        session: 'Session 2',
        type: 'Regular',
        date: '2025-09-13',
        remark: ''
      }
      // Add more sample rows here
    ];
    selectedCentre: any;
    selectedCentreObjects: any[] = [];
    // array of selected centre codes (used in filtering when multiple selected)
    selectedCentreCodes: string[] = [];
    expandedRemarks: { [key: string]: boolean } = {};

    constructor(private afs: AngularFirestore,
                private centreService: CentreService,
                private router: Router,
                private dialog: MatDialog,
                private counsellingService: CounselingService) {
      this.centres$ = this.centreService.getAllCentres()
      this.centresWithAll$ = this.centres$.pipe(
        map(arr => [{ centreName: 'All Centres', centreCode: 'All' }, ...(arr || [])])
      );
    }

    ngOnInit(): void {
      const today = new Date();
      this.selectedMonth = today.getMonth() + 1;
      this.selectedYear = null;  // ← null so dropdown shows nothing selected
      this.selectedCentreObjects = [];
      this.selectedCentreCodes = [];
    }

    ngAfterViewInit() {
      this.dataSource.paginator = this.paginator; // paginator attached first
      this.filterMonthlyData();                   // THEN load default data
    }

    applyFilter(e: any) {
    }

    onCentreSelected(selected: any[]) {

      if (!selected || selected.length === 0) {
        this.selectedCentreObjects = [];
        this.selectedCentreCodes = [];
        return;
      }

      // store full objects
      this.selectedCentreObjects = selected;

      // store only centre codes for filtering
      this.selectedCentreCodes = selected.map(c => c.centreCode);

      console.log("Selected Centres:", this.selectedCentreCodes);
    }
    loadCounsellingList(): Promise<any[]> {
      return firstValueFrom(
        this.afs.collection(this.env.counsellingCenterLog)
          .valueChanges({ idField: 'id' })
          .pipe(
            map((res: any[]) =>
              res.map(item => ({
                ...item,
                date: item.date?.toDate ? item.date.toDate()
                  : item.date?.seconds ? new Date(item.date.seconds * 1000)
                    : new Date(item.date)
              }))
            )
          )
      ).then(processedData => {
        this.allData = processedData;
        const sorted = this.sortCounsellingData([...processedData]);
        this.dataSource.data = sorted;
        return processedData;
      });
    }

    toggleRemark(id: string): void {
      this.expandedRemarks[id] = !this.expandedRemarks[id];
    }

    // Add this method to check if remark is expanded
    isRemarkExpanded(id: string): boolean {
      return !!this.expandedRemarks[id]; // Double negation converts to proper boolean
    }

    // Add this method to check if remark is long
    isRemarkLong(remark: any): boolean {
      return remark && remark.length > 100; // Adjust character limit as needed
    }

    // Add this method to get truncated remark
    getTruncatedRemark(remark: string): string {
      if (!remark) return '';
      return remark.length > 100 ? remark.substring(0, 100) + '...' : remark;
    }

    AddCenterCounsellingLog() {
      const dialogRef = this.dialog.open(AddEditCounsellingCentreLogComponent, {
        width: '100%',
        height: '600px',
        disableClose: true,
        data: {mode: 'add'}
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          // Reload and sort data after adding new entries
          this.filterMonthlyData();
        }
      });
    }

    openEdit(row: any) {
      const dialogRef = this.dialog.open(AddEditCounsellingCentreLogComponent, {
        width: '900px',
        height: '400px',
        disableClose: true,
        data: {
          mode: 'edit',
          docId: row.id      // Firestore docId
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          // Reload and sort data after editing
          this.filterMonthlyData();
        }
      });
    }

    deleteDoc(id: any) {
      if (confirm('Are you sure you want to delete this entry?')) {
        this.afs.collection(this.env.counsellingCenterLog).doc(id).delete()
          .then(() => {
            console.log('Entry deleted successfully');
            // Reload and sort data after deletion
            this.filterMonthlyData();
          })
          .catch(error => {
            console.error('Error deleting entry:', error);
            alert('Error deleting entry');
          });
      }
    }

    clearFilters() {
      this.selectedCentreObjects = [];
      this.selectedCentreCodes = [];
      this.selectedMonth = null;
      this.selectedYear = null;
      this.dataSource.data = [];

      if (this.paginator) {
        this.paginator.firstPage();
      }
    }
    async filterMonthlyData() {
      await this.loadCounsellingList();
      if (!this.allData || this.allData.length === 0) return;

      // When selectedYear is null (default), fall back to current year
      const effectiveYear = this.selectedYear ?? new Date().getFullYear(); // ← KEY CHANGE

      let filtered = this.allData.filter(item => {
        const d = new Date(item.date);
        const month = d.getMonth() + 1;
        const year = d.getFullYear();

        const matchMonth = !this.selectedMonth || month === this.selectedMonth;
        const matchYear = year === effectiveYear; // ← uses effectiveYear, not selectedYear

        const matchCentre = (() => {
          if (this.selectedCentreCodes && this.selectedCentreCodes.length > 0) {
            return this.selectedCentreCodes.includes(item.centreCode);
          }
          if (!this.selectedCentre || this.selectedCentre === 'All') return true;
          return item.centreCode === this.selectedCentre;
        })();

        return matchMonth && matchYear && matchCentre;
      });

      filtered = this.sortCounsellingData(filtered);
      this.dataSource.data = filtered;
      this.checkAndUpdateSessionDocumentation(filtered);
    }

    checkAndUpdateSessionDocumentation(rows: any[]) {
      this.counsellingService.fetchIndividualSession()
        .pipe(take(1))
        .subscribe(sessions => {
          rows.forEach(row => {
            if (row.sessionDocumented === "Yes") return; // Already documented

            // Convert row.date to JavaScript Date
            const rowDate = row.date?.toDate ? row.date.toDate() : new Date(row.date);
            const formDateStr = rowDate.toISOString().split('T')[0];

            const matched = sessions.find((s:any) => {
              const sessionDate = s.date?.toDate ? s.date.toDate() : new Date(s.date);
              const sessionDateStr = sessionDate.toISOString().split('T')[0];

              return (
                s.centreCode === row.centreCode &&
                s.childCode === row.childCode &&
                sessionDateStr === formDateStr
              );
            });

            if (matched) {
              console.log("MATCH FOUND → Updating sessionDocumented = Yes");
              this.afs.doc(`${this.env.counsellingCenterLog}/${row.id}`)
                .update({ sessionDocumented: "Yes" });
              // Update in sessions collection
              this.afs.doc(`${this.counsellingService.env.counseling}/allSessions/sessions/${matched.id}`)
                .update({ sessionDocumented: "Yes" });
            }
          });

        });
    }

    sortCounsellingData(data: any[]): any[] {
      return data.sort((a, b) => {

        // 1️⃣ Date (newest → oldest)
        const dateA = a.date?.toDate ? a.date.toDate() : new Date(a.date);
        const dateB = b.date?.toDate ? b.date.toDate() : new Date(b.date);
        const dateCompare = dateB.getTime() - dateA.getTime();
        if (dateCompare !== 0) return dateCompare;

        // 2️⃣ Centre name (A → Z)
        const centreCompare = a.centreName.localeCompare(b.centreName);
        if (centreCompare !== 0) return centreCompare;

        // 3️⃣ Child name (A → Z)
        const childCompare = a.childName.localeCompare(b.childName);
        if (childCompare !== 0) return childCompare;

        // 4️⃣ Session number (Session 1, Session 2...)
        const sessionA = Number(a.session.replace(/\D/g, ''));
        const sessionB = Number(b.session.replace(/\D/g, ''));

        return sessionA - sessionB;
      });
    }


    protected readonly PermissionType = PermissionType;
  }
